import { Spin, SpinProps } from 'antd'
import React, { ReactNode } from 'react'
import { useFela } from 'react-fela'
import ds from 'views/styles/designSystem'
import Loader from './Loader'

export interface SpinnerProps extends SpinProps {
  children?: ReactNode
  variant?: 'gradient' | 'white'
  height?: number
  width?: number
  wrapperHeight?: string | number
  onElement?: boolean
  marginTop?: string | number
}

const Spinner: React.FC<SpinnerProps> = ({
  children,
  height = 30,
  width = 30,
  variant = 'gradient',
  wrapperHeight = '100%',
  marginTop = 3,
  onElement = false,
  spinning,
  ...props
}) => {
  const { css } = useFela()
  return (
    <div className={css(rules.wrapper({ wrapperHeight, marginTop, onElement }))} data-cy="spinner">
      <div {...(onElement && { className: css(rules.spin()) })}>
        <Spin indicator={<Loader variant={variant} height={height} width={width} />} {...props} spinning={spinning} />
      </div>
      {children && <div className={css(rules.children({ onElement, spinning }))}>{children}</div>}
    </div>
  )
}

const rules = {
  wrapper: ({ wrapperHeight, marginTop, onElement }) => ({
    color: ds.brand('gradient'),
    marginTop: marginTop,
    height: wrapperHeight,
    wrapperHeight: wrapperHeight,
    position: 'relative',
    display: onElement ? 'block' : 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  spin: () => ({
    position: 'absolute',
    zIndex: 500000,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  }),
  children: ({ onElement, spinning }) => ({
    marginLeft: 10,
    opacity: onElement && spinning ? 0.6 : 1,
    pointerEvents: onElement && spinning ? 'none' : 'auto',
  }),
}

export default Spinner
